import { queryOptions } from '@tanstack/react-query'
import getOrder from '../api/get-order'

export const getOrderQueryKey = (orderId: string) => ['order', orderId] as const

export const getOrderQueryOptions = (orderId: string) =>
  queryOptions({
    queryKey: getOrderQueryKey(orderId),
    queryFn: () => getOrder(orderId),
    staleTime: 60_000,
  })
